var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7432 12.1094L16.7432 15.6691C16.7432 16.1412 16.5556 16.5939 16.2218 16.9277C15.8881 17.2615 15.4353 17.449 14.9633 17.449L2.50411 17.449C2.03205 17.449 1.57933 17.2615 1.24554 16.9277C0.911749 16.5939 0.724226 16.1412 0.724226 15.6691L0.724226 12.1094",
    stroke: "#3CA48E",
    strokeWidth: 1.28587,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28345 7.6582L8.73316 12.1079L13.1829 7.6582",
    stroke: "#3CA48E",
    strokeWidth: 1.28587,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7334 12.109L8.7334 1.42969",
    stroke: "#3CA48E",
    strokeWidth: 1.28587,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeal);
export default __webpack_public_path__ + "static/media/teal.d041a180.svg";
export { ForwardRef as ReactComponent };